import { createAction, createSlice } from '@reduxjs/toolkit';

export type HomeData = {
	'employeeName': string,
	'imageUrl': string,
	'description': string,
	'dateOfJoining': string,
	'buzzBoardId': string,
	'buzzType': string,
	'projectName': string,
	'link': string

}

const sortFeedData = (data: any[]) => {
	return [...data]?.sort((a, b) => {
		const dojA = a?.dateOfJoining;
		const dojB = b?.dateOfJoining;

		if (dojA === dojB) {
			// ascending updatedAt (older at top, newer at bottom)
			return a?.updatedAt - b?.updatedAt;
		}

		// descending dateOfJoining (newer posts at top)
		return dojB - dojA;
	});
};


// const initialState: HomeData = {
//     'employeeName': '',
//     'imageUrl': '',
//     'dateOfJoining': ''
// };

const initialState: HomeData[] = [];

export const revertAll = createAction('REVERT_ALL');

export const homeReducer = createSlice({
	name: 'homeReducer',
	initialState,
	reducers: {
		setHomeData: (state, action) => {
			const sorted = sortFeedData(action.payload);
			return sorted;
		},
		addHomeData: (state, action) => {
			const updated = sortFeedData([action.payload, ...state]);
			return updated;
		},
		updateHomeData: (state, action) => {
			const updated = state.map(data =>
				data.buzzBoardId === action.payload.buzzBoardId ? action.payload : data
			);
		
			return sortFeedData(updated);
		},
		
		deleteHomeData: (state, action) => {

			const indexOfHomeDataToDelete = state.findIndex(data => data.buzzBoardId === action.payload.buzzBoardId);

			if (indexOfHomeDataToDelete !== -1) {

				const savedData = state;

				// removing item using slice since its faster than filter
				state = [
					...savedData.slice(0, indexOfHomeDataToDelete),
					...savedData.slice(indexOfHomeDataToDelete + 1)];
			}
			return state;
		}

	}

});
export const { setHomeData, addHomeData, updateHomeData, deleteHomeData } = homeReducer.actions;
export default homeReducer;
